import React, { useEffect, useMemo, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { updateTableData } from "../../store/actions/cartAction";

function Paypal(props) {
  const { amount, forwardFees, getPaypalDetail, setPayment } = props;
  const { restaurantsDetail } = useSelector((state) => state.restaurants);
  const paypal = useRef();
  const dispatch = useDispatch();
  const { uid } = useSelector((state) => state.authUser);
  function calculateFinalAmount(amount, forwardFees) {
    if (!forwardFees) {
      return amount;
    }
    if (forwardFees?.type === "fixed_price") {
      return amount + parseFloat(forwardFees?.fixedAmount);
    } else if (forwardFees?.type === "percentage") {
      const percentage = parseFloat(forwardFees?.percentageAmount) / 100;
      return amount + amount * percentage;
    } else if (forwardFees?.type === "both") {
      let percentage = parseFloat(forwardFees?.percentageAmount) / 100;
      return (
        amount + parseFloat(forwardFees?.fixedAmount) + amount * percentage
      );
    }
    return amount;
  }
  const finalAmount = useMemo(
    () => calculateFinalAmount(amount, forwardFees),
    [amount, forwardFees]
  );

  let taxAmount = "";

  if (forwardFees?.type === "fixed_price") {
    taxAmount = forwardFees.fixedAmount;
  } else if (forwardFees?.type === "percentage") {
    taxAmount = parseFloat(forwardFees.percentageAmount);
  } else if (forwardFees?.type === "both") {
    taxAmount = `${parseFloat(forwardFees.percentageAmount)}% + ${
      forwardFees.fixedAmount
    }`;
  }

  useEffect(() => {
    if (!restaurantsDetail?.paypalClientKey) return;
    const script = document.createElement("script");
    script.src = `https://www.paypal.com/sdk/js?client-id=${restaurantsDetail.paypalClientKey}&currency=USD`;
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);

    script.onload = () => {
      if (paypal.current && window.paypal) {
        window.paypal
          .Buttons({
            createOrder: (data, actions) => {
              return actions.order.create({
                intent: "CAPTURE",
                purchase_units: [
                  {
                    reference_id: "default",
                    description: "Account Fee",
                    amount: {
                      currency_code: "USD",
                      value: finalAmount.toString(),
                    },
                  },
                ],
              });
            },
            onApprove: async (data, actions) => {
              const order = await actions.order.capture();
              getPaypalDetail(order, finalAmount);
              setPayment("Paypal");
              const obj = props?.orders;
              if (obj.tableNumber) {
                dispatch(
                  updateTableData(
                    obj.restaurantID,
                    uid,
                    obj.tableNumber,
                    obj.timer,
                    restaurantsDetail?.name
                  )
                );
              }
            },
            onError: (err) => {
              toast.error(err.message || "Payment failed");
            },
          })
          .render(paypal.current);
      }
    };

    return () => {
      document.body.removeChild(script);
    };
  }, [finalAmount, restaurantsDetail?.paypalClientKey]);

  return (
    <>
      <div ref={paypal}></div>
      {taxAmount && taxAmount > 0 && (
        <div className="d-flex justify-content-center my-2">
          <span className="fs--22 fw--400">
            {" "}
            {props?.forwardFees?.type === "percentage"
              ? "%"
              : props.orders?.order[0]?.currency}
          </span>
          <span className="fs--22 fw--400 mr-2">
            Tax Fees: {}
            {taxAmount || 0}
          </span>
        </div>
      )}
      <div className="d-flex justify-content-center my-1">
        <span className="fs--22 fw--400 mr-1">
          Total Amount: {finalAmount ? finalAmount?.toFixed(2) : 0}
        </span>
        <span className="fs--22 fw--400">
          {props.orders?.order[0]?.currency}
        </span>
      </div>
    </>
  );
}

export default Paypal;
